
import './styles.css';
import InsaneTable from '../../component/insane-table';

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function ProductionResultPDChecksheetSurvey(props) {
    const PARAM = props.location.state;

    let timeslotList = [];

    function convertTimeslotHour(hour) {
        let hourString = hour;
        if (hour < 10) { hourString = ("0" + hour) };
        return (hourString + ":00")
    }
    
    HttpRequest("/admin/pd/timeslot/get", {}).then(data => {
        // console.log(data);
        if (data.result === "OK") {
            for (let i = 0; i < data.timeslots.length; i++) {
                const _timeslot = data.timeslots[i];
                let timeslotTime = convertTimeslotHour(_timeslot.timeslothour);
                timeslotList.push({
                    displayName: _timeslot.timeslotname + " " + timeslotTime,
                    value: _timeslot.timeslotid
                })
            }
        }
    });

    const tableOption = {
        tableName: "Survey",
        className: "",
        search: [
            // {
            //     reqName: "timeslotid",
            //     displayName: "Timeslot",
            //     placeholder: "Select Timeslot.",
            //     element: "select",
            //     option: timeslotList
            // },
            {
                reqName: "from",
                displayName: "Start Date",
                element: "datetime-local"
            },
            {
                reqName: "to",
                displayName: "End Date",
                element: "datetime-local"
            },
            {
                reqName: "approved",
                displayName: "Approved",
                placeholder: "",
                element: "select",
                option: [
                    {
                        displayName: "YES",
                        value: "yes"
                    },
                    {
                        displayName: "NO",
                        value: "no"
                    },
                ]
            }
        ],
        mapTable: [
            // {
            //     displayName: "checksheetid",
            //     attName: "checksheetid",
            //     type: "text",
            // },
            { displayName: "Survey NO."        , attName: "surveyno"          , type: "text"      , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Survey Date"       , attName: "surveydate"        , type: "date"      , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Timeslot"          , attName: "timeslotid"        , type: "id"        , form: { validate: true, enable: true, element: "select", option: timeslotList } },
            { displayName: "User"              , attName: "label_userlabel"   , type: "text"      , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Remark"            , attName: "remark"            , type: "text"      , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Tag Normal"        , attName: "tagresult_normal"  , type: "text-color", form: { validate: true, enable: true, element: "input" }, color: "#02c944" },
            { displayName: "Tag Abnormal"      , attName: "tagresult_abnormal", type: "text-color", form: { validate: true, enable: true, element: "input" }, color: "#ff0100" },
            // { displayName: "Tag Total"         , attName: "tagresult_total"   , type: "text-color", form: { validate: true, enable: true, element: "input" }, color: "" },
            { displayName: "Tag Remark"        , attName: "tagresult_remark"  , type: "text-color", form: { validate: true, enable: true, element: "input" }, color: "#ffc100" },
            // { displayName: "Approved"          , attName: "approved"          , type: "approve"   , form: { validate: true, enable: true, element: "input" } },
            { displayName: "Approved"  , attName: ["label_approveduser","approvedtime"] , type: "merge"  , form: { validate: true, enable: true, element: "input" } },
            // { displayName: "Approved By"       , attName: "label_approveduser", type: "text"      , form: { validate: true, enable: true, element: "input" } }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/survey/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "from": "",
                    "to": "",
                    "checksheetid": PARAM.checksheetid
                }
            },
            insert: {
                enable: false,
                url: "",
                dataReq: {}
            },
            update: {
                enable: true,
                url: "",
                dataReq: {}
            },
            delete: {
                enable: true,
                url: "",
                dataReq: {}
            }
        },
        action: [
            {
                name: "Tag Result",
                mode: "page", /// page, modal, form
                option: {
                    url: "/d-rec-admin/main/production/result-pd/checksheet/survey/tag"
                }
            }
        ]
    }

    // console.log(tableOption);

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Select Survey.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default ProductionResultPDChecksheetSurvey;